import React from "react";

const ContactSection = () => (
  <section className="py-16 bg-white text-center">
    <h2 className="text-4xl font-extrabold text-red-600 mb-4">Need Help? Reach Out</h2>
    <a href="tel:+918344405645" className="text-3xl font-extrabold text-gray-700 mb-2">+91 83444 05645</a>
  </section>
);

export default ContactSection; 